export default "__VITE_ASSET__oYidyOID__"